module.exports = __webpack_public_path__ + "img/revenue_ru.ff6c87f2.png";